/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/plm_appCommonService";

const initialState = {
  apSample: {
    data: [],
    status: true,
    articleNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const plmSlice = createSlice({
  name: "plm",
  initialState,
  reducers: {
    // articleNr(state, action) {
    //   state.apSample.articleNr = action.payload;
    // },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getArticleList.pending, (state, action) => {
  //       state.apSample.status = true;
  //     })
  //     .addCase(getArticleList.fulfilled, (state, action) => {
  //       state.apSample.data = action.payload.data;
  //       state.apSample.pagination.page = action.payload.page;
  //       state.apSample.pagination.per_page = action.payload.per_page;
  //       state.apSample.pagination.total = action.payload.total;
  //       state.apSample.status = false;
  //     });
  // },
});

export const { articleNr } = plmSlice.actions;

// export const getArticleList = createAsyncThunk(
//   "getArticleList",
//   async (param) => {
//     console.log(">> loaded getArticleList");
//     const res = await ItemService.generatePlmQuery(param);
//     return res;
//   }
// );

export default plmSlice.reducer;
